<template>
  <layout-fullscreen bg="/images/photo-1.jpg">
    <remax-logo />
    <h1 class="heading h2 t-inverse t-center">
      We know property inside out,
      <span class="t-light t-normal">so let's find your perfect match.</span>
    </h1>
    <router-link class="button button--outline" to="/wizard">Get Started</router-link>
  </layout-fullscreen>
</template>

<style scoped lang="scss">
  .heading {
    max-width: 350px;
    margin-bottom: 40px;

    @include min-sm {
      max-width: 550px;
    }
  }
</style>

<script>
  import LayoutFullscreen from '@/layouts/Fullscreen';
  import RemaxLogo from '@/components/RemaxLogo';

  export default {
    name: 'Landing',

    components: {
      LayoutFullscreen,
      RemaxLogo
    },

    props: {

    },

    data: () => ({
      
    }),

    computed: {

    },

    methods: {

    },

    created () {

    }
  };
</script>